// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as UsersRouteImport } from './app/users'
import { Route as TemplatesRouteImport } from './app/templates'
import { Route as SettingsRouteImport } from './app/settings'
import { Route as RegulationsRouteImport } from './app/regulations'
import { Route as RatecardRouteImport } from './app/ratecard'
import { Route as PrivacyRouteImport } from './app/privacy'
import { Route as NotificationsRouteImport } from './app/notifications'
import { Route as LoginRouteImport } from './app/login'
import { Route as LibraryRouteImport } from './app/library'
import { Route as LearningRouteImport } from './app/learning'
import { Route as JoinRouteImport } from './app/join'
import { Route as InviteRouteImport } from './app/invite'
import { Route as GoogleRouteImport } from './app/google'
import { Route as EntitiesRouteImport } from './app/entities'
import { Route as DealsRouteImport } from './app/deals'
import { Route as ContractorsRouteImport } from './app/contractors'
import { Route as ComplaintsRouteImport } from './app/complaints'
import { Route as CabinetRouteImport } from './app/cabinet'
import { Route as IndexRouteImport } from './app/index'
import { Route as InviteTokenRouteImport } from './app/invite_.$token'
import { Route as EstimatesIdRouteImport } from './app/estimates.$id'
import { Route as DealIdRouteImport } from './app/deal.$id'
import { Route as ContractorIdRouteImport } from './app/contractor.$id'
import { Route as CabinetRequisitesRouteImport } from './app/cabinet_.requisites'

const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const TemplatesRoute = TemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const RegulationsRoute = RegulationsRouteImport.update({
            id: '/regulations',path: '/regulations',getParentRoute: () => rootRouteImport
          })
const RatecardRoute = RatecardRouteImport.update({
            id: '/ratecard',path: '/ratecard',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          })
const LearningRoute = LearningRouteImport.update({
            id: '/learning',path: '/learning',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const InviteRoute = InviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => rootRouteImport
          })
const GoogleRoute = GoogleRouteImport.update({
            id: '/google',path: '/google',getParentRoute: () => rootRouteImport
          })
const EntitiesRoute = EntitiesRouteImport.update({
            id: '/entities',path: '/entities',getParentRoute: () => rootRouteImport
          })
const DealsRoute = DealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => rootRouteImport
          })
const ContractorsRoute = ContractorsRouteImport.update({
            id: '/contractors',path: '/contractors',getParentRoute: () => rootRouteImport
          })
const ComplaintsRoute = ComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => rootRouteImport
          })
const CabinetRoute = CabinetRouteImport.update({
            id: '/cabinet',path: '/cabinet',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite_/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const EstimatesIdRoute = EstimatesIdRouteImport.update({
            id: '/estimates/$id',path: '/estimates/$id',getParentRoute: () => rootRouteImport
          })
const DealIdRoute = DealIdRouteImport.update({
            id: '/deal/$id',path: '/deal/$id',getParentRoute: () => rootRouteImport
          })
const ContractorIdRoute = ContractorIdRouteImport.update({
            id: '/contractor/$id',path: '/contractor/$id',getParentRoute: () => rootRouteImport
          })
const CabinetRequisitesRoute = CabinetRequisitesRouteImport.update({
            id: '/cabinet_/requisites',path: '/cabinet/requisites',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CabinetRoute: CabinetRoute,ComplaintsRoute: ComplaintsRoute,ContractorsRoute: ContractorsRoute,DealsRoute: DealsRoute,EntitiesRoute: EntitiesRoute,GoogleRoute: GoogleRoute,InviteRoute: InviteRoute,JoinRoute: JoinRoute,LearningRoute: LearningRoute,LibraryRoute: LibraryRoute,LoginRoute: LoginRoute,NotificationsRoute: NotificationsRoute,PrivacyRoute: PrivacyRoute,RatecardRoute: RatecardRoute,RegulationsRoute: RegulationsRoute,SettingsRoute: SettingsRoute,TemplatesRoute: TemplatesRoute,UsersRoute: UsersRoute,CabinetRequisitesRoute: CabinetRequisitesRoute,ContractorIdRoute: ContractorIdRoute,DealIdRoute: DealIdRoute,EstimatesIdRoute: EstimatesIdRoute,InviteTokenRoute: InviteTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)